<template>
  <div class="d-flex flex-column flex-md-row min-vh-100 bg-light">
    <Sidebar />
    <main class="flex-fill p-4 mt-5 mt-md-0">
      <h1 class="h3 fw-bold mb-4" style="padding-left:24px">{{ title }}</h1>
      <p v-if="description" class="text-muted mb-4" style="padding-left:24px">{{ description }}</p>
      <slot />
    </main>
  </div>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue';

export default {
  name: 'Layout',
  components: {
    Sidebar,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped></style>
